import { render, staticRenderFns } from "./jira_integration_container.vue?vue&type=template&id=5013434f&scoped=true&"
import script from "./jira_integration_container.vue?vue&type=script&lang=js&"
export * from "./jira_integration_container.vue?vue&type=script&lang=js&"
import style0 from "./jira_integration_container.vue?vue&type=style&index=0&id=5013434f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013434f",
  null
  
)

export default component.exports